module.exports = __webpack_public_path__ + "media/images/global/projects/science-0cccf4d0a8042e32fabce724a745f2c8.svg";